export default "__VITE_ASSET__a1b1875a__"